// extracted by mini-css-extract-plugin
module.exports = {"container":"mantri_container__MMrCz","box_menu":"mantri_box_menu__3177c"};